import React from "react";
import { useSelector } from "react-redux";
import { Button,  Flex, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { colors } from "../../../../../../constants/colors";
import { routes } from "../../../../../../constants";
import { baseRouteMaker } from "../../../../../../constants/routeConsts";
import "./WalletInfo.scss";
import { useTranslation } from "react-i18next";

const WalletInfoPaymentDetails = () => {

  const {t} = useTranslation();

  /* navigate dependencies */
  const navigate = useNavigate();
  /* navigate dependencies */
  
  const { selectedWalletInfoPlanDetails } = useSelector(
    (state) => state.walletInfo
  );

  return (
    <div style={{
      background: "linear-gradient(to bottom, #1a64af, #58b647)",
        padding: 20,
        color: colors.white,
        height: "100%",
      }}>
      <Flex gap="1rem" style={{ marginBottom: "2rem" }}>
        <Button
          type="default"
          shape="circle"
          size="small"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(baseRouteMaker(routes.DASHBOARD))}
        />
        <Typography.Title style={{ color: colors.white }} level={2}>
          {t("CommonUtils.payment")}
        </Typography.Title>
      </Flex>

      <Flex
        gap="3rem"
        vertical
        style={{ maxWidth: 500, margin: "auto" }}
      >
        <Flex vertical>
          <Flex>
            <Typography.Paragraph
              style={{ color: colors.white, margin: 0 }}
            >
              {t("CommonUtils.addWalletPoints")}
            </Typography.Paragraph>
            <Typography.Title
              level={4}
              style={{ color: colors.white, margin: 0 }}
            ></Typography.Title>
          </Flex>
          <Flex gap="1rem" align="center">
            <Typography.Title
              level={1}
              style={{ color: colors.white, margin: 0 }}
            >
              {`${selectedWalletInfoPlanDetails?.amount} ${t("CommonUtils.walletPoints")}` || 0}
            </Typography.Title>
          </Flex>
        </Flex>

        <Flex>
          <Typography.Paragraph
            style={{ color: colors.white, margin: 0 }}
          >
            {t("CommonUtils.efficiencyAndTimeSavings")}
          </Typography.Paragraph>
        </Flex>

        <Flex justify="space-between">
          <Flex vertical>
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              ReynaCare
            </Typography.Paragraph>
            <Typography.Paragraph
              style={{ color: colors.white, margin: 0 }}
            >
              {t("CommonUtils.billFor")}{" "}
              {`${selectedWalletInfoPlanDetails?.amount} ${t("CommonUtils.points")}` || 0}
            </Typography.Paragraph>
          </Flex>

          <Typography.Paragraph
            style={{ color: colors.whiteSmoke, margin: 0 }}
          >
            {`${selectedWalletInfoPlanDetails?.amount.toFixed(
              2
            )} ${selectedWalletInfoPlanDetails?.currency}` || 0}
          </Typography.Paragraph>
        </Flex>

        <Flex vertical gap="1rem">
          <Flex justify="space-between">
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.subtotal")}
            </Typography.Paragraph>

            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {`${selectedWalletInfoPlanDetails?.amount.toFixed(
              2
            )} ${selectedWalletInfoPlanDetails?.currency}` || 0}
            </Typography.Paragraph>
          </Flex>

          <hr
            style={{
              backgroundColor: colors.lightWhite,
              border: "none",
              height: "0.1px",
              width: "100%",
            }}
          />

          <Flex justify="space-between">
            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {t("CommonUtils.totalDueToday")}
            </Typography.Paragraph>

            <Typography.Paragraph
              style={{ color: colors.whiteSmoke, margin: 0 }}
            >
              {`${selectedWalletInfoPlanDetails?.amount.toFixed(
              2
            )} ${selectedWalletInfoPlanDetails?.currency}` || 0}
            </Typography.Paragraph>
          </Flex>
        </Flex>
      </Flex>
      </div>
  )
}

export default WalletInfoPaymentDetails;